export default __webpack_public_path__ + "static/media/buch.dd9c979c.pdf";